import { Col, LegacyForm, Row } from "@payping/web-components";
import React from "react";
import type { FormInstance } from "@payping/web-components/legacyComponents/Form/types";
import { useAsync } from "react-use";
import { useAppDispatch, useAppSelector } from "@/utils";
import { formatLocalizedNumber } from "@payping/utilities-shared/number";
import { SamanConfiguration, SamanCreateFormType, SamanOverviewType } from "@/pages/DigitalAccount/Saman/Create";
import { setSamanOverviewDetail } from "@payping/redux/actions";
import SamanShowList from "@/pages/DigitalAccount/Saman/Create/ThirdStep/SamanShowList";

interface Props {
  form: FormInstance<SamanCreateFormType>;
  formStepOne: FormInstance<SamanConfiguration>;
  setOverviewData: React.Dispatch<React.SetStateAction<SamanOverviewType>>;
}

const ThirdStepSaman: React.FC<Props> = ({ form, formStepOne, setOverviewData }) => {
  const paymentDetailsModels = useAppSelector((state) => state.digitalAccount.saman.requestList?.paymentDetailsModels);
  const dispatch = useAppDispatch();

  useAsync(async () => {
    const overviewDetail = await dispatch(
      setSamanOverviewDetail({
        description: formStepOne.getFieldValue("description"),
        name: formStepOne.getFieldValue("title"),
        sendPaymentRequestDetails: paymentDetailsModels?.map((item) => ({
          amount: item.amount,
          destinationAccountOwner: item.fullName,
          destinationIBan: item.iban,
          reasonCode: item.reasonCode,
          name: item.description,
          description: item.description,
        })),
      }),
    );

    if (overviewDetail?.totalWage !== undefined && overviewDetail.amount !== undefined) {
      setOverviewData({
        total: formatLocalizedNumber({ value: overviewDetail.amount / 10 }),
        totalWage: formatLocalizedNumber({ value: Math.trunc(overviewDetail.totalWage / 10) }),
        totalAmount: formatLocalizedNumber({
          value: Math.trunc(overviewDetail.amount + overviewDetail.totalWage) / 10,
        }),
      });
    }
  });

  return (
    <LegacyForm<SamanCreateFormType> form={form} name={"SamanCreateFormType"} className="tw:w-full" layout={"vertical"}>
      <Row gutter={[8, 16]} className={"w-100"}>
        <Col xs={24}>
          <SamanShowList />
        </Col>
      </Row>
    </LegacyForm>
  );
};

export default ThirdStepSaman;
